import type { ReactNode } from "react";

interface ButtonProps {
  variant?: "primary" | "secondary" | "destructive";
  fullWidth?: boolean;
  type?: "button" | "submit";
  onClick?: () => void;
  disabled?: boolean;
  children: ReactNode;
  "data-testid"?: string;
}

export function Button({
  variant = "primary",
  fullWidth = false,
  type = "button",
  onClick,
  disabled,
  children,
  "data-testid": testId,
}: ButtonProps) {
  const variantCls =
    variant === "primary"
      ? "bg-primary hover:bg-primary-tint text-on-primary"
      : variant === "secondary"
        ? "bg-surface-raised border border-divider hover:bg-surface text-on-surface"
        : "bg-error hover:bg-error/90 text-on-primary";

  const widthCls = fullWidth ? "w-full" : "";
  const disabledCls = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <button
      type={type}
      className={`h-11 font-semibold rounded-md focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ps-4 pe-4 transition-colors duration-200 ${variantCls} ${widthCls} ${disabledCls}`}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
    >
      {children}
    </button>
  );
}
